import React from 'react';
import classNames from 'classnames';

const StepContent = ({ className, children }) => {
  const classes = classNames('ws-ui-step-line-content', className);

  return <div className={classes}>{children}</div>;
};

export default StepContent;
